import { render, staticRenderFns } from "./NewProcess.vue?vue&type=template&id=33051209&scoped=true&"
import script from "./NewProcess.vue?vue&type=script&lang=js&"
export * from "./NewProcess.vue?vue&type=script&lang=js&"
import style0 from "./NewProcess.vue?vue&type=style&index=0&id=33051209&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33051209",
  null
  
)

export default component.exports